import React, { useState, useEffect, useCallback, useRef } from "react"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import { notBlank, imgSize, jnstyls } from '~/utils/helpers'

import FavProd from '~/components/shared/fav-prod'
import TilePk from '~/components/tile/tile-pk'
import TileVintage from '~/components/tile/tile-vintage'
import VideoBg from '~/components/video/bg'
import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import { aria_btn, cta_link } from "~/styles/app.module.scss"
import { arrowbtn } from "~/styles/pages/factory.module.scss"
import { sec } from "~/styles/blog/blog.module.scss"
import * as styles from "~/styles/carousel/carousel_products.module.scss"
import * as tstyles from "~/styles/tiles/tile.module.scss"

const CarouselProducts = ({ block, index, is_blog=true }) => {
  const { isMobile, customer } = useTheme()

  const settings = block.hasOwnProperty('settings') ? block.settings : block

  let products = settings.products || []
  if (products.length) products = products.filter(x => x.hasOwnProperty('media') && x.media.length > 0)

  const [didLoad, setDidLoad] = useState(false)
  const [pos, setPos] = useState(0)
  const [scrollauto, setScrollauto] = useState(false)
  const [backon, setBackon] = useState(false)
  const [forwon, setForwon] = useState(true)
  const wrapRef = useRef(null)
  const slideRef = useRef(null)

  const total = products.length

  const handleBack = () => {
    setScrollauto(true)
    const inview = arrow_inview()
    let new_pos = inview[0] - 1 - (isMobile ? 0 : inview.length)
    if (new_pos < 0) new_pos = 0
    setPos(new_pos)
  }

  const handleForward = () => {
    setScrollauto(true)
    const inview = arrow_inview()
    let new_pos 
    if (inview.length) {
      new_pos = inview[inview.length - 1] + (isMobile ? 0 : 1)
      if (new_pos + inview.length >= total) new_pos = total - 1
      if (inview.length === 1) new_pos = inview[0] + 1
    } else {
      new_pos = total
    }
    setPos(new_pos)
  }

  const arrow_inview = () => {
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const arr = Array.from(wrap.querySelectorAll(`.${styles.tile}`))

    let inview = []
    arr.forEach((x, index) => {
      const el = x.getBoundingClientRect()
      const el_left = el.left - wrap_rect.left 
      const el_right = el.left + el.width - wrap_rect.left - (isMobile ? 13 : 0)
      const plus_wrap = (wrap_rect.width * 1.9) + 13

      

      if (isMobile) {
        if (el_left > ((wrap_rect.width - 13) * -1) && el_right <= plus_wrap) inview.push(index)
      } else {
        if (el_left >= 0 && el_right < wrap_rect.width) inview.push(index)
      }
    })
    return inview
  }

  const deskChange = useCallback(() => {
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const curr_scroll = wrap.scrollLeft

    const arr = Array.from(wrap.querySelectorAll(`.${styles.tile}`))
    const next = arr[pos].getBoundingClientRect()
    const next_scroll = next.left + (curr_scroll - wrap_rect.left)

    wrap.scrollTo({
      top: 0,
      left: next_scroll,
      behavior: 'smooth'
    });
    setTimeout(() => {
      setScrollauto(false)
    }, 250)
  }, [pos])

  let scrollTimeout = null

  const handleSnap = () => {
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const arr = Array.from(wrap.querySelectorAll(`.${styles.tile}`))

    let inview = null
    let best = 0
    arr.forEach((x, index) => {
      const el = x.getBoundingClientRect()
      const el_left = el.left - wrap_rect.left 
      const el_right = el.left + el.width - wrap_rect.left
      const w_wide = wrap_rect.width

      if ((el_left <= 0 && (el_right >= 0 && el_right < w_wide)) || (el_left >= 0 && el_right < (w_wide * 2))) {
        const showing = (w_wide - 13) - (Math.abs(el_left))
        if (showing > best) {
          best = showing
          inview = index
        }
      }
    })
    setPos(inview)
    setTimeout(() => {
      setScrollauto(false)
    }, 250)
  }

  const scroll_stop = () => {
    if (scrollauto) return
    setScrollauto(true)
    scrollTimeout = null
    handleSnap()
  }

  const checkScroll = () => {
    const wrap = wrapRef.current
    const max_scrll = Math.floor(wrap.scrollWidth - wrap.getBoundingClientRect().width) - 1
    
    const new_back = wrap.scrollLeft >= 1
    if (new_back !== backon) setBackon(new_back)

    const new_forw = wrap.scrollLeft <= max_scrll
    if (new_forw !== forwon) setForwon(new_forw)

    if (isMobile) {
      if (scrollTimeout !== null) {
        clearTimeout(scrollTimeout);
      }
      if (!scrollauto) scrollTimeout = setTimeout(scroll_stop, 200);
    }
  }

  const test_media = (media) => {
    if (block.id === 1925) {
      return media.slice(0,1)
    }
    if (media.length <= 2) return media

    return media.slice(0,2)
  }

  const checkEvent = () => {
    const ids = [2516]
    if (!ids.includes(block.id)) return
    window._conv_q = window._conv_q || []
    window._conv_q.push(["triggerConversion", "100471748"])
  }

  useEffect(() => {
    setDidLoad(true)
    
  }, [])

  useEffect(() => {
    if (!slideRef.current) return
    deskChange()
    
  }, [pos, slideRef, deskChange])

  useEffect(() => {
    const el = wrapRef.current
    if ( el ) {
      el.addEventListener('scroll', checkScroll, { passive: true })

      return () => {
        el.removeEventListener('scroll', checkScroll)
      }
    }
  })

  const options = (item) => {
    return {
      autoplay: true,
      controls: false,
      children: ['mediaLoader', 'posterImage'],
      setPlaysinline: true,
      playsinline: true,
      muted: true,
      loop: true,
      sources: item.sources.filter(x => x.mimeType !== 'application/x-mpegURL').map((x) => {
        return {src: x.url, type: x.mimeType}
      })
    }
  }

  let wrap_styles = [styles.wrap, sec]
  if (is_blog) {
    wrap_styles = wrap_styles.concat([styles.blog_wrap])
  }
  if (!is_blog) {
    wrap_styles = wrap_styles.concat([styles.home_wrap])
  }
  
  return (
    <div 
      className={wrap_styles.join(' ')}
      mok-block={is_blog ? undefined : index} 
      g={block.gender ? block.gender : undefined}
      mid={is_blog ? undefined : block.id}
    >
      <div className={jnstyls([styles.head, notBlank(settings.title) ? '' : styles.notitle])}>
        <div className={styles.title}>
          {(notBlank(settings.carousel_handle) && notBlank(settings.title)) ? (
            <Flink 
              href={`/collections/${settings.carousel_handle}`} 
              className={styles.title_link}
              onClick={(e)=> checkEvent()}
            >
              {settings.title}
            </Flink>
          ) : (
            <>{notBlank(settings.title) ? settings.title : ''}</>
          )}
        </div>  
        <div className={styles.desk_arrows}>
          <button 
            type="button"
            className={jnstyls([aria_btn, arrowbtn, styles.dsk_arrowbtn, backon ? '' : styles.off])}
            aria-label="Scroll Back" 
            onClick={(e)=>{handleBack()}}
          >
            <IconChevLeft icon_classes="" />
          </button>
          <button 
            type="button"
            className={jnstyls([aria_btn, arrowbtn, styles.dsk_arrowbtn, styles.forw, forwon ? '' : styles.off])}
            aria-label="Scroll Forward" 
            onClick={(e)=>{handleForward()}}
          >
            <IconChevRight icon_classes="" />
          </button>
        </div>
      </div>
      <div className={styles.tees_groups} ref={wrapRef}>
        <div className={jnstyls([styles.groups, styles.tiles])}>
          {products && products.map( (product, index) =>
            <React.Fragment key={product.shop_id}>
              {(product.pl_pima !== 99998 && !product.is_vintage) ? (
                <div 
                  key={product.shop_id} 
                  className={jnstyls([styles.tile, tstyles.tile])}
                  ref={pos === index ? slideRef : undefined}
                >
                  <meta itemProp="name" content={product.title} />
                  <meta itemProp="url" content={`https://www.buckmason.com/products/${product.handle}`} />
                  <meta itemProp="image" content={product.media[0].image} />

                  <div className={[styles.images, tstyles.images].join(' ')}>
                    <Flink 
                      href={`/products/${product.handle}`} 
                      className={jnstyls([tstyles.tile_link, styles.tile_link])} 
                      aria-label={product.title} 
                      onClick={(e)=> checkEvent()}
                    >
                      {test_media(product.media).map( (item, index) => 
                        <React.Fragment key={item.image || item.src}>
                          {item?.type === 'VIDEO' ? (
                            <VideoBg 
                              options={options(item)}
                              vidclasses={styles.tile_vid}
                              off={false}
                              />
                          ) : (
                            <img 
                              key={item.image}
                              src={imgSize(item.image,600)} 
                              alt={item.alt} 
                              className={index === 0 ? undefined : styles.img_2} 
                              width="300  " 
                              height="400" 
                              decode="async"
                            />
                          )}
                        </React.Fragment>
                      )}
                    </Flink>

                    {product.altcuts && (
                      <div className={tstyles.alts}>
                        {product.altcuts.opts.length} {product.altcuts.type}{product.altcuts.opts.length > 1 ? 's' : ''}
                      </div>
                    )}
                  </div>

                  <div className={tstyles.infos}>
                    <div className={tstyles.info}>
                      <Flink 
                        href={`/products/${product.handle}`} 
                        className={jnstyls([tstyles.tile_link, tstyles.tile_title])} 
                        onClick={(e)=> checkEvent()}
                      >
                        {notBlank(product.pl_name) ? product.pl_name : product.title}
                      </Flink>
                      <div data-product-price className={tstyles.price}>
                        <span className={tstyles.price}>${product.price}</span>
                      </div>
                    </div>

                    {(didLoad && customer && localStorage.getItem('ward')) && (
                      <FavProd prod_id={product.mid} tile={true} />
                    )}

                    <div className={jnstyls([tstyles.info, tstyles.color])}>
                      {product.color}
                    </div>
                  </div>
                </div>
              ) : (product.is_vintage) ? (
                <div 
                  key={product.shop_id} 
                  className={jnstyls([styles.tile, tstyles.tile])}
                  ref={pos === index ? slideRef : undefined}
                >
                  <TileVintage 
                    key={``} 
                    product={product} 
                    tile_ind={index} 
                    isInView={true} 
                    parStyles={jnstyls([styles.images, styles.imagespk])}
                  />
                </div>
              ) : (
                <div 
                  key={product.shop_id} 
                  className={jnstyls([styles.tile, tstyles.tile])}
                  ref={pos === index ? slideRef : undefined}
                >
                  <TilePk 
                    key={``} 
                    product={product} 
                    tile_ind={index} 
                    isInView={true} 
                    parStyles={jnstyls([styles.images, styles.imagespk])}
                  />
                </div>
              )}
            </React.Fragment>
          )}
          {notBlank(settings.carousel_handle) && (
            <Flink 
              href={`/collections/${settings.carousel_handle}`} 
              className={jnstyls([styles.tile, tstyles.tile])} 
              onClick={(e)=> checkEvent()}
            >
              <div className={styles.carou_bg}>
                <div className={styles.carou_cont}>
                  {settings.carousel_link_count > 0 && (
                    <p>
                      View {settings.carousel_link_count} more product{settings.carousel_link_count > 1 ? 's' : ''} 
                    </p>
                  )}
                  <div className={cta_link}>{settings.carousel_cta}</div>
                </div>
              </div>
            </Flink>
          )}
        </div>
      </div>
      <button 
        type="button"
        className={jnstyls([aria_btn, arrowbtn, styles.mob_arrowbtn, styles.arrowbtn, backon ? '' : styles.off])}
        aria-label="Scroll Back" 
        onClick={(e)=>{handleBack()}}
      >
        <IconChevLeft icon_classes="" />
      </button>
      <button 
        type="button"
        className={jnstyls([aria_btn, arrowbtn, styles.mob_arrowbtn, styles.arrowbtn, styles.forw, forwon ? '' : styles.off])}
        aria-label="Scroll Forward" 
        onClick={(e)=>{handleForward()}}
      >
        <IconChevRight icon_classes="" />
      </button>
    </div>
  )
}

export default CarouselProducts



